import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";

const API_URL = "http://192.168.1.44:1337";
// const imageUrl = "https://picsum.photos/200/300";

function App() {
  const [articles, setArticles] = useState({ data: [] });
  useEffect(() => {
    fetch("http://localhost:1337/api/articles?populate=*")
      .then((response) => response.json())
      .then((data) => setArticles(data))
      .catch((error) => console.error(error));
  }, []);
  console.log(articles);
  return (
    <div>
      <Container>
        <h1>Articles List</h1>
        <Row className="justify-content-center">
          {articles.data.map((article) => (
            <Col md={4} key={article.id}>
              <Card>
                {/* <Card.Img src={API_URL + article.cover.formats.medium.url} />  */}
                <Card.Img src={API_URL + article.cover.url} />
                <Card.Body>
                  <Card.Title className="text-truncate">
                    {article.title}
                  </Card.Title>
                  <Card.Text className="text-truncate">
                    {article.description}
                  </Card.Text>
                  <hr></hr>
                  <Card.Text>{article.slug}</Card.Text>
                  <Button variant="primary">Go somewhere</Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default App;
